import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFlashcards: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFlashcards"><Path d="M10.3672 7L10.8139 2.75L21.2564 3.84755L19.8452 17.2736L14.2586 16.6864" stroke="currentColor"/><Path d="M2.70312 7.79481L13.1456 6.69727L14.5567 20.1233L4.11426 21.2209L2.70312 7.79481Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFlashcards;
